import { css } from 'linaria';

export const descriptionStyle = css`
  max-width: 767px;
  margin: 0 0 32px;

  @media (--only-desktop) {
    max-width: 740px;
    margin-bottom: 40px;
  }

  @media (--to-desktop) {
    max-width: 100%;
    margin-bottom: 24px;
  }
`;
